export function scrollIntoView() {

    if (!document.getElementById("userNameErrorMessage")) {
        return null;
    }
    if (!document.getElementById("passwordErrorMessage")) {
        return null;
    }
    
    function isVisible(element) {
        return window.getComputedStyle(element).display !== 'none';
    }

    var userNameErrorMessage = document.getElementById("userNameErrorMessage");
    if (isVisible(userNameErrorMessage)) {
        document.getElementById("loginForm").scrollIntoView();
    }

    var passwordErrorMessage = document.getElementById("passwordErrorMessage");
    if (isVisible(passwordErrorMessage)) {
        document.getElementById("loginForm").scrollIntoView();
    }
}